import { call, put, takeLatest, delay } from 'redux-saga/effects';

import { getCurrentRef } from '../helpers';
import { promptToast } from '../../../components/toast-container/actions';

export function* redirectVerifiedUser({ mode }) {
  const { push, replace } = window.__history; // eslint-disable-line no-underscore-dangle
  switch (mode) {
    case 'autologin': {
      yield call(push, getCurrentRef().path);
      yield delay(500);

      yield put(
        promptToast(
          'success',
          window.APP_GLOBALS.t('account', 'signup.success')
        )
      );
      break;
    }
    case 'login': {
      yield call(replace, '/login');
      yield put(
        promptToast(
          'success',
          window.APP_GLOBALS.t('account', 'login.successful')
        )
      );
      break;
    }
    default:
  }
}

function* mySaga() {
  yield takeLatest('VERIFY_ACCOUNT_COMPLETE', redirectVerifiedUser);
}

export default mySaga;
